// Card spacing
export const CARD_GAP = 16;

// Intersection Observer
export const INTERSECTION_THRESHOLD = 0.3;
